import React from 'react';

import {ACTION} from 'constants/index.js';

import EditApplicationButton from 'Components/EditApplicationButton';

export default ({status, user, familyId, loadInProgress, type, performFamilyActionFunction}) => {
  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div
        className='go-back-to-list-header-button'
        onClick={() => {
          user.goToFamilyList(false);
        }}
      >
        Back
      </div>
      <header>{type ? type.componentTypeName : ''} Component Family</header>
      {!loadInProgress && (
        <React.Fragment>
          <EditApplicationButton onClick={() => performFamilyActionFunction(ACTION.EDIT, familyId)} />
          <div className={`detailsScene__status-label ${status.toLowerCase()}`}>
            {status.toLowerCase().replace('_', ' ')}
          </div>
        </React.Fragment>
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Details/Header.jsx